import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import {
  updateNotifications,
  updateUserNotifications,
  getNotifications,
  koalaAnalyticsActions,
  getUserNotifications,
  getConsentStatements,
  updateUserConsent,
  closeConsentModal,
} from 'actions';
import NotificationsFormComponent from 'components/NotificationsForm/NotificationsFormComponent';
import { forms, features } from 'constants';
import { resetAppErrors } from 'actions/setters/updateAppErrors';

const fetchData = dispatch => dispatch(getNotifications());
const fetUserData = dispatch => dispatch(getUserNotifications());

const NotificationsFormContainer = reduxForm({
  form: forms.Notifications,
})(NotificationsFormComponent);

const mapStateToProps = state => ({
  status: {
    isFetching: state.app.notifications.isFetching,
    ...state.app.appErrors,
  },
  initialValues: state.app.notifications.data,
  consents: state.app.notifications.consents,
  showConsentModal: state.app.notifications.showConsentModal,
  consentStatementsStatus: {
    isFetching: state.app.consents.isFetching,
  },
  isOptionSelected: state.app.consents.isOptionSelected,
  userConsent: state.app.consents.userConsent,
  consentStatements: state.app.consents.consentStatements,
});

export const mapDispatchToProps = dispatch => ({
  submitHandler: values => {
    if (features.preferencesService) {
      return dispatch(updateUserNotifications(values));
    }
    return dispatch(updateNotifications(values));
  },
  fetchData: () => {
    if (features.preferencesService) {
      fetUserData(dispatch);
    } else {
      fetchData(dispatch);
    }
  },
  fetchConsentStatements: () => dispatch(getConsentStatements()),
  updateUserConsent: (i, consent) => dispatch(updateUserConsent(i, consent)),
  closeConsentModal: () => dispatch(closeConsentModal()),
  trackPageView: (subtype, pageSection) => {
    koalaAnalyticsActions.trackPageView(subtype, pageSection)(dispatch);
  },
  trackLinkClick: (subtype, pageSection, eventValue) => {
    koalaAnalyticsActions.trackLinkClick(
      subtype,
      pageSection,
      eventValue,
    )(dispatch);
  },
  resetAppErrors: () => {
    dispatch(resetAppErrors());
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps, { features });

const NotificationsFormContainerConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(NotificationsFormContainer);

NotificationsFormContainerConnected.fetchData = fetchData;

export default NotificationsFormContainerConnected;
